<template>
  <v-container class="header-container fin-page-404" fill-height fluid>
    <v-row>
      <v-col align="center" class="py-0 fin-page-404-illu" justify="center">
        <v-img :src="require('@/assets/error/page-not-found.svg')"
               contain
               :max-height="364"
               :max-width="1125"
               :style="{ marginTop: $vuetify.breakpoint.xs ? '29px' : '68px'}"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center" class="py-0" justify="center">
        <h3 v-if="$vuetify.breakpoint.smAndUp" style="margin-top: 89px; margin-bottom: 12px;">Kein Ausweg aus dem
          Finanz-Dschungel?</h3>
        <h6 v-else style="margin-top: 48px; margin-bottom: 4px;">Kein Ausweg aus dem Finanz-Dschungel?</h6>

        <h1 v-if="$vuetify.breakpoint.smAndUp" style="margin-bottom: 32px;">Wir geben dir den Kompass!</h1>
        <h2 v-else style="margin-bottom: 24px;">Wir geben dir den Kompass!</h2>

        <p
          :style="{ fontSize: $vuetify.breakpoint.xs ? '16px' : '18px', maxWidth: $vuetify.breakpoint.xs ? '300px' : '100%', marginBottom: '24px' }">
          Ups 404 – Diese Seite können wir leider nicht finden.<br v-if="$vuetify.breakpoint.smAndUp"/>
          Gehe zur Startseite zurück oder melde dich bei finCraft an.
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col align="center" class="py-0" justify="center">
        <v-btn class="back-button mb-6" style="border-radius: 0" to="/">
          <span class="back-button-text pl-2 pr-2">Zurück {{ userId ? 'zum Dashboard' : 'zur Startseite' }}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: 'fin-not-found',
  computed: {
    ...mapGetters('auth', ['userId']),
  }
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.fin-page-404 {
  background-color: $fin-color-primary-dark !important;
}

.back-button {
  color: #ffffff;
  background-color: $fin-color-primary-dark;
  margin-bottom: 12px;
}

h3 {
  font-family: $body-font-family;
  font-size: 24px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.1;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

h6 {
  font-family: $body-font-family;
  font-size: 16px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

h1 {
  font-family: $heading-font-family;
  font-size: 48px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.13;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

h2 {
  font-family: $heading-font-family;
  font-size: 32px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}

p {
  font-family: $body-font-family;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-light;
}
</style>
